<template>
    <div class="app-container page-detail">
        <div class="page-block width-master">
            <div class="page-breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }"
                        >首页</el-breadcrumb-item
                    >
                    <el-breadcrumb-item :to="{ path: '/news/list' }">{{
                        $route.meta.title
                    }}</el-breadcrumb-item>
                    <el-breadcrumb-item>正文</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <div class="page-content post">
                <div class="post-title">
                    <h2>{{ post.title.rendered }}</h2>
                </div>
                <div class="post-date">
                    {{ post.date | formatDate("yyyy-MM-dd") }}
                </div>
                <div class="post-content" v-html="post.content.rendered"></div>
            </div>

            <div class="page-other">
                <CardListOne class="card-list__post" />
            </div>
        </div>
    </div>
</template>
<script>
import CardListOne from "@/components/CardListOne.vue";
import apiWpV2 from "@/api/wp";
export default {
    name: "Detail",
    components: {
        CardListOne,
    },
    data() {
        return {
            name: "Detail",
            post: {
                id: 4039,
                date: "2021-05-15T06:00:44",
                date_gmt: "2021-05-15T06:00:44",
                guid: {
                    rendered: "https://www.xiongsu.cn/?p=4039",
                },
                modified: "2021-05-19T06:15:40",
                modified_gmt: "2021-05-19T06:15:40",
                slug: "%e7%ac%ac%e4%b8%89%e5%b1%8a5-15%e5%85%a8%e5%9b%bd%e6%8a%95%e8%b5%84%e8%80%85%e4%bf%9d%e6%8a%a4%e5%ae%a3%e4%bc%a0%e6%97%a5",
                status: "publish",
                type: "post",
                link: "https://www.xiongsu.cn/2021/05/15/%e7%ac%ac%e4%b8%89%e5%b1%8a5-15%e5%85%a8%e5%9b%bd%e6%8a%95%e8%b5%84%e8%80%85%e4%bf%9d%e6%8a%a4%e5%ae%a3%e4%bc%a0%e6%97%a5/",
                title: {
                    rendered: "第三届“5.15全国投资者保护宣传日”",
                },
                content: {
                    rendered:
                        '<p><img loading="lazy" class="size-large wp-image-4043 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/05/2222-1024x436.jpg" alt="" width="1024" height="436" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/05/2222-1024x436.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/05/2222-300x128.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/05/2222-768x327.jpg 768w, https://www.xiongsu.cn/wp-content/uploads/2021/05/2222.jpg 1080w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p>&nbsp;</p>\n<p>为维护中小投资者合法权益，保障资本市场持续健康发展，积极响应中国证券监督管理委员会“第三届5.15全国投资者保护宣传日”的号召，广东雄塑科技集团股份有限公司提醒您，对各类“股市黑嘴”、“非法荐股”、“场外配资”提高防范意识，避免侥幸心理、谨防诈骗，不轻信免费荐股电话、短信、微信、直播等，自觉远离违法活动，保护好自己的财产安全。</p>\n<p>&nbsp;</p>\n<p><img loading="lazy" class="size-large wp-image-4040 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/05/1-1024x512.jpg" alt="" width="1024" height="512" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/05/1-1024x512.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/05/1-300x150.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/05/1-768x384.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p>&nbsp;</p>\n<p><img loading="lazy" class="size-large wp-image-4041 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/05/2-1024x512.jpg" alt="" width="1024" height="512" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/05/2-1024x512.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/05/2-300x150.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/05/2-768x384.jpg 768w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p>&nbsp;</p>\n<p><img loading="lazy" class="size-large wp-image-4042 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-1024x1024.jpg" alt="" width="1024" height="1024" srcset="https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-1024x1024.jpg 1024w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-150x150.jpg 150w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-300x300.jpg 300w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-768x768.jpg 768w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-250x250.jpg 250w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-86x86.jpg 86w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-427x427.jpg 427w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-120x120.jpg 120w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-31x31.jpg 31w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-95x95.jpg 95w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-270x270.jpg 270w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-370x370.jpg 370w, https://www.xiongsu.cn/wp-content/uploads/2021/05/123.4-72x72.jpg 72w" sizes="(max-width: 1024px) 100vw, 1024px" /></p>\n<p>&nbsp;</p>\n<p>中国投资者网（www.investor.org.cn）是中国证监会管理的公益网络服务平台，为投资者提供知识普及、权益维护、互动交流等信息和服务。中国投资者网，投资者自己的网站！更多咨询速递、知识普及、投资者互动、维权敬请关注中国投资者网！</p>\n<p>&nbsp;</p>\n<p><img loading="lazy" class="size-full wp-image-4045 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/05/图片2.png" alt="" width="149" height="187" /></p>\n<p>&nbsp;</p>\n<p><img loading="lazy" class="size-full wp-image-4044 aligncenter" src="https://www.xiongsu.cn/wp-content/uploads/2021/05/图片1.png" alt="" width="130" height="177" /></p>\n',
                    protected: false,
                },
                excerpt: {
                    rendered:
                        "<p>2018年11月19日上午，南海区九江镇为了进一步落实乡村振兴战略，推动乡村旅游发展，推进美丽文明村居建设，依托璜矶鹭鸟天堂为背景舞台，以风景美丽的百足桥为T台，联同区书法协会、美术协会进行现场挥毫创作，同时联合南海区医用卫用行业协会进行无纺布时装及用品展示，继而举办的企业及团体展示产品或展示自我创意的鹭鸟天堂旗袍时装T台秀活动圆满落幕。</p>\n",
                    protected: false,
                },
                author: 1,
                featured_media: 4049,
                comment_status: "open",
                ping_status: "open",
                sticky: false,
                template: "",
                format: "standard",
                meta: [],
                categories: [3],
                tags: [],
                acf: false,
                _links: {
                    self: [
                        {
                            href: "https://www.xiongsu.cn/wp-json/wp/v2/posts/4039",
                        },
                    ],
                    collection: [
                        {
                            href: "https://www.xiongsu.cn/wp-json/wp/v2/posts",
                        },
                    ],
                    about: [
                        {
                            href: "https://www.xiongsu.cn/wp-json/wp/v2/types/post",
                        },
                    ],
                    author: [
                        {
                            embeddable: true,
                            href: "https://www.xiongsu.cn/wp-json/wp/v2/users/1",
                        },
                    ],
                    replies: [
                        {
                            embeddable: true,
                            href: "https://www.xiongsu.cn/wp-json/wp/v2/comments?post=4039",
                        },
                    ],
                    "version-history": [
                        {
                            count: 2,
                            href: "https://www.xiongsu.cn/wp-json/wp/v2/posts/4039/revisions",
                        },
                    ],
                    "predecessor-version": [
                        {
                            id: 4050,
                            href: "https://www.xiongsu.cn/wp-json/wp/v2/posts/4039/revisions/4050",
                        },
                    ],
                    "wp:featuredmedia": [
                        {
                            embeddable: true,
                            href: "https://www.xiongsu.cn/wp-json/wp/v2/media/4049",
                        },
                    ],
                    "wp:attachment": [
                        {
                            href: "https://www.xiongsu.cn/wp-json/wp/v2/media?parent=4039",
                        },
                    ],
                    "wp:term": [
                        {
                            taxonomy: "category",
                            embeddable: true,
                            href: "https://www.xiongsu.cn/wp-json/wp/v2/categories?post=4039",
                        },
                        {
                            taxonomy: "post_tag",
                            embeddable: true,
                            href: "https://www.xiongsu.cn/wp-json/wp/v2/tags?post=4039",
                        },
                    ],
                    curies: [
                        {
                            name: "wp",
                            href: "https://api.w.org/{rel}",
                            templated: true,
                        },
                    ],
                },
            },
        };
    },
    watch: {
        $route(to, from) {
            // 监听路由是否变化
            // console.info(to)
            if (to.params.contentId !== from.params.contentId) {
                // set default
                // this.articles = []
                // this.paging = []
                this.getPost(); // 重新加载数据
            }
        },
    },
    mounted() {
        this.getPost();
    },
    methods: {
        async getPost() {
            let self = this;
            let postData = await apiWpV2.getPostById({
                id: self.$route.params.contentId,
            });

            self.post = postData.data;
        },
    },
};
</script>
<style lang="scss">
.post {
    border-top: 1px solid #e8e8e8;
    padding-top: 60px;
    &-title {
        font-size: 24px;
        padding-bottom: 30px;
    }
    &-date {
        font-size: 16px;
        padding-bottom: 30px;
    }
    &-content {
        color: #333;
        font-size: 16px;
        line-height: 26px;
        padding: 0 100px;
        figure {
            margin: 0;
            img {
                max-width: 100%;
                height: auto;
            }
            figcaption {
                font-size: 12px;
                color: #999;
                text-align: center;
                margin-top: 10px;
                margin-bottom: 20px;
            }
        }
        img {
            max-width: 100%;
            display: block;
            height: auto;
            margin: 0 auto;
        }
    }
}
.mobile {
    .post {
        width: 90vw;
        margin: 0 auto;
        padding-top: 10vw;

        &-title {
            font-size: 14px;
            text-align: center;
            padding-bottom: 3vw;
        }
        &-date {
            font-size: 12px;
            color: #999;
            padding-bottom: 6vw;
        }

        &-content {
        font-size: 13px;
        line-height: 1.6;
        padding: 0;
        img {
            max-width: 100%;
            display: block;
            margin: 0 auto;
        }
    }
    }
    
}
</style>
